var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
var Pager = (function () {
    function Pager() {
        this.onNext = new EventEmitter(false);
        this.onPrev = new EventEmitter(false);
        this.onGoto = new EventEmitter(false);
        this.curPage = 0;
        this.locked = false;
    }
    Pager.prototype.ngOnInit = function () {
        this.reloadPageCount(this.pcount);
    };
    Pager.prototype.reloadPageCount = function (count) {
        this.pages = new Array(Math.ceil(this.pcount / this.psize)).map(function (x, i) { return i; });
        //console.log("pager(" + this.pcount + ", " + this.psize + ", " + this.pages.length + " pages)");
        this.curPage = 0;
        this.pcount = this.pages.length - 1;
    };
    Pager.prototype.setLock = function (block) {
        this.locked = block;
    };
    Pager.prototype.isLocked = function () {
        return this.locked;
    };
    Pager.prototype.nextPage = function () {
        if (this.curPage < this.pcount) {
            this.onNext.emit(++this.curPage);
        }
    };
    Pager.prototype.prevPage = function () {
        if (this.curPage > 0) {
            this.onPrev.emit(--this.curPage);
        }
    };
    Pager.prototype.goToPage = function (num) {
        if (num != this.curPage) {
            this.curPage = num;
            this.onGoto.emit(num);
        }
    };
    Pager.prototype.getClassItem = function (i) {
        var classes = "page-item";
        if (this.curPage == i) {
            classes = "active " + classes;
        }
        return classes;
    };
    Pager.prototype.finalize = function () {
        this.pages = [];
        this.curPage = -1;
        this.pcount = 0;
        this.psize = 5;
    };
    return Pager;
}());
__decorate([
    Input(),
    __metadata("design:type", Number)
], Pager.prototype, "pcount", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], Pager.prototype, "psize", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Pager.prototype, "onNext", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Pager.prototype, "onPrev", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Pager.prototype, "onGoto", void 0);
Pager = __decorate([
    Component({
        moduleId: module.id,
        selector: 'pager-view',
        templateUrl: './pager.component.html'
    })
], Pager);
export { Pager };
//# sourceMappingURL=pager.component.js.map